/// <reference path="../liquid.d.ts" />

export * from "./catalog/index";
export * from "./customers/index";
export * from "./orders/index";
export * from "./payment_terminals/index";
export * from "./printers/index";
export * from "./reports/index";
export * from "./session/index";
export * from "./shop/index";
export * from "./tables/index";
export * from "./users/index";
export * from "./checkout/index";
export * from "./payment_integrations/index";
export * from "./payment_integrations/configs/index";
export * from "./payments";
export * from "./printer/index";
export * from "./updates/index";
export * from "./images/index";
export * from "./customer_checkouts/index";
export * from "./auth/index";
export * from "./date-time/index";
// Note: wallet/apple exports are server-side only (Node.js APIs)
// Import directly from "./wallet" in server code if needed
export * from "./reservations";
export * from "./events";
export * from "./email";

export const pp = (a: any) => JSON.parse(JSON.stringify(a));

export {
  humanize,
  truncateStaffName,
  shortenStaffName,
  getDeliveryCities,
} from "@lemmonhq/orders";

export const logToRemoteServer = async (data: Record<string, any>) => {
  try {
    await fetch("https://webhook.site/d347443a-2ff7-4bdf-a34d-63726e57d46a", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        timestamp: new Date().toISOString(),
        ...data,
      }),
    });
  } catch (error) {
    console.error("Error logging to remote server:", error);
  }
};
